// @ts-check
import { getAll, getById } from "@/utilities/querySelector";
import { toggleScroll } from "@/utilities/toggleScroll";


/** Check for support of 'command' attribute */
function supportsCommands() {
    return HTMLButtonElement.prototype.hasOwnProperty( 'command' );
}

/**
 * Always allow doc scrolling when dialogs close.
 * Probably won't work for double dialogs...
 */
const dialogs = getAll( 'dialog' );
dialogs.forEach( dialog => {
    dialog.addEventListener( 'close', () => {
        toggleScroll( true );
    } );
} );


if ( !supportsCommands() ) {
    initDialogListeners();
} else {
    const scrollHandler = event => {
        if ( event.command !== 'show-modal' ) return;
        toggleScroll( false );
    };
    dialogs.forEach( dialog => {
        dialog.addEventListener( 'command', scrollHandler );
    } );
}

function initDialogListeners() {
    const triggers = getAll( 'button[command]' );

    triggers.forEach( trigger => {
        trigger.addEventListener( 'click', handleCommand );
    } );
}

function handleCommand( e ) {
    const command = e.currentTarget.getAttribute( 'command' );
    const targetID = e.currentTarget.getAttribute( 'commandfor' );
    const target = getById( targetID );

    if ( !target ) {
        console.warn( 'No commandtarget with ID: ' + targetID );
        return;
    }

    switch ( command ) {
        case 'show-modal':
            openDialog( target );
            break;
        case 'close':
            closeDialog( target );
            break;
    }
}

/**
 * @param {HTMLDialogElement} dialog
 */
function openDialog( dialog ) {
    dialog.showModal();
    toggleScroll( false );
}

/**
 *
 * @param {HTMLDialogElement} dialog
 */
function closeDialog( dialog ) {
    dialog.close();
    toggleScroll( true );
}
